import './i18n';

import React from 'react';
import ReactDOM from 'react-dom';

import { AppPostHogProvider } from './analytics/posthog';
import App from './App';
// import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <AppPostHogProvider>
    <App />
  </AppPostHogProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
